<template>
	<div class="rightInner">
		<div class="searchArea">
			<div class="title">
				<div class="titleLine"></div>
				{{$t('mypages.afterSale.title')}}
			</div>
			<div>
				<div class="conditions">
					<div class="condition">
						<div class="conditionLabel">{{$t('mypages.afterSale.label_platform_order_no')}}</div>
						<input type="text" class="small" :placeholder="$t('mypages.afterSale.placeholder_platform_order_no')" v-model="form.orderNo"/>
					</div>
					<div class="condition">
						<div class="conditionLabel">{{$t('mypages.afterSale.label_product_name')}}</div>
						<input type="text" class="small" :placeholder="$t('mypages.afterSale.placeholder_product_name')" v-model="form.productName"/>
					</div>
					<div class="condition">
						<div class="conditionLabel">{{$t('mypages.afterSale.label_service_no')}}</div>
						<input type="text" class="small" :placeholder="$t('mypages.afterSale.placeholder_service_no')" v-model="form.serviceNo"/>
					</div>
				</div>
				<div  class="conditions setPadding">
					<div class="condition">
						<div class="conditionLabel timeLabel">{{$t('mypages.afterSale.label_apply_time')}}</div>
						<div class="calendarArea">
							<div class="calendarInner" @click="strarShow()">
								<input type="text" v-model="form.startTime"/>
								<img  src="../../assets/images/dateIcon.png"/>
							</div>
							<div class="calendatPopup" v-if="isStart">
								<CalendarVue @changeDate="getDate" :initDay="calendarInitDay"></CalendarVue>
							</div>
						</div>
						<div class="calendarLine">~</div>
						<div class="calendarArea">
							<div class="calendarInner"  @click="endShow()">
								<input type="text"   v-model="form.endTime"/>
								<img  src="../../assets/images/dateIcon.png"/>
							</div>
							<div class="calendatPopup" v-if="isEnd">
								<CalendarVue @changeDate="getDate" :initDay="calendarInitDay"></CalendarVue>
							</div>
						</div>
								<div class="searchBtn btnStyle" @click="Search()">{{$t('mypages.afterSale.search')}}</div>
								<div class="resetBen btnStyle" @click="Reset()">{{$t('mypages.afterSale.reset')}}</div>
					</div>
				</div>
			</div>
			
		</div>
		<table>
			<thead>
				<th>售后单号</th>
				<th>平台订单号</th>
				<th>商品名称</th>
				<th style="width:203px;">规格型号</th>
				<th>购买数量</th>				
				<th>售后数量</th>
				<th>操作/状态</th>
			</thead>
			<tbody>
				<tr v-for="(item,index) in salesList" :key="item.id">
					<td><div class="tdInner">{{item.service_no}}</div></td>
					<td><div class="tdInner">{{item.order_no}}</div></td>
					<td><div class="tdInner">{{item.product_name}}</div></td>
					<td><div class="tdInner">{{item.sku_text}}</div></td>
					<td><div class="tdInner">{{item.buy_number}}</div></td>
					<td><div class="tdInner">{{item.number}}</div></td>
					<td><div class="tdInner">
						<p v-if="item.service_type==1">已退款</p>
						<p v-else>已換貨</p>
					</div></td>
				</tr>
			</tbody>
		</table>
		<div class="paginationArea">
						<PaginationVue  :TotalCount="totalcount" :pageSize="10" @pageChenged="handlePage"></PaginationVue>
					</div>
	</div>
</template>

<script>
	import CalendarVue from "../../components/calendar.vue"
	import PaginationVue from '../../components/pagination.vue';
	export default{
			components:{
				CalendarVue,
				PaginationVue
			},data(){
			return {
				calendarInitDay: '2024-12-1',
				isStart: false,
				isEnd:false,
				allItems:['1','2','3','4','5','6','7','8','9','10','11','12','13','14'],
				salesList:[],
				totalcount:1,
				pageIndex:1,
				form: {
					orderNo: '',
					serviceNo: '',
					startTime: '',
					endTime: '',
					productName:''
				},
			}
		},
		created(){
			this.getInvoiceListInfo();
		},
		mounted(){
			 document.addEventListener('click', this.hideCalendar)
		},		
		methods:{			
			handlePage(message) {
				console.log(message);
				this.pageIndex = message;
				this.getOrderListInfo();
			},
			getDate(d){
				console.log(d)
				if(this.isStart){
					this.isStart = !this.isStart;
					this.form.startTime=d;
					return;
				}
				if(this.isEnd){
					this.isEnd = !this.isEnd;
					this.form.endTime=d;
					return;
				}
			},
			strarShow(){
				this.isStart = true;
				this.isEnd = false;
			},
			endShow(){
				this.isEnd = true;
				this.isStart = false
			},
			hideCalendar(event){
			    if (!event.target.closest('.calendarArea')) {
					this.isStart = false;
					this.isEnd = false;
				}
			},
			detailClick(){
				this.$emit('detailClick')
			},
			getInvoiceListInfo() {
				this.salesList=[];
				this.$scUtil.axiosPut(this, 'SalesApi/GetOrderServicePageList', {
					orderNo: this.form.orderNo,
					serviceNo:this.form.serviceNo,
					productName:this.form.productName,
					startTime:this.form.startTime,
					endTime:this.form.endTime,
					userName: localStorage.getItem('username'),
					pageIndex:this.pageIndex,
					pageSize:10,
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.salesList = res.data;
						this.totalcount=res.totalcount;
						console.log(JSON.stringify(this.salesList))

					}

				});
			},
			Search()
			{
					this.getInvoiceListInfo();
			},
			Reset(){
				this.form.orderNo='';
				this.form.invoiceNo='';
				this.form.saleNo='',
				this.form.startTime='',
				this.form.endTime='',
				this.getInvoiceListInfo();
			}
		}
	}
</script>

<style scoped>
	.rightInner{
		width: 958px
	}
	.searchArea{
		width: 100%;	
		background-color: #fff;
	}
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	
	.conditions,.condition{
		display: flex;
		align-items: center;
	}
	
	.conditions{
		margin-top: 20px;
		padding-left: 20px;
	}
	
	.conditionLabel{
		font-size: 13px;
		color: #000000;
		margin-right: 10px;
		width: 80px;
		text-align: right;
	}
	
	.small{
		width: 158px;
		height: 32px;
	}
	
	.condition input{
		border: 1px solid #e2e2e2;
		font-size: 13px;
		color: #000;
		padding-left: 10px;
	}
	
	.condition input:focus{
		outline: none;
	}
	
	.condition input::placeholder{
		color: #888;
	}
	
	.condition{
		margin-right: 40px;
	}
	
	.condition:nth-last-child(1){
		margin-right: 0px;
	}
	
	.calendarArea{
		position: relative;
		display: flex;
		align-items: center;
	}	
	
	.calendarArea input{
		height: 170px;
		height: 32px;
		border: none;
	}
	
	.calendarInner{
		width: 200px;
		height: 32px;
		border: 1px solid #e2e2e2;
	}
	
	.calendatPopup{
		position: absolute;
		width: 260px;
		top: 34px;
		left: 0;
		background-color: #fff;
		box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.1),
		0 1px 5px 0 rgba(0, 0, 0, 0.12);
	}
	
	.calendarLine{
		margin: 0 15px;
	}
	
	.setPadding{
		padding-bottom: 20px;
		border-bottom: 1px solid #e2e2e2;
	}
	
	.searchBtn{		
		color: #ffffff;
		background-color: #0380fe;
		border: 1px solid #0380fe;	
		margin-left: 36px;
	}
	
	.resetBen{
		color: #ffffff;
		border: 1px solid #e2e2e2;
		color: #666666;
		margin-left: 17px;
	}
	
	.btnStyle{
		width:105px;
		height: 32px;
		font-size: 13px;
		border-radius: 5px;
		text-align: center;
		line-height: 32px;
		cursor: pointer;
	}
	
	table{
		width: 100%;
		background-color: #fff;
		border-collapse: collapse;
		padding: 0 20px;
		box-sizing: border-box;
		margin-top: 20px;
	}
	
	table thead th{
		font-size: 13px;
		color: #333333;
		border-bottom: 2px solid #e2e2e2;
		height: 60px;
	}
	
	table tbody tr td{
		color: #000000;
		font-size: 12px;
		text-align: center;
		padding: 20px 0;
		border-bottom: 1px solid #e2e2e2;
	}
	
	table tbody tr td:nth-child(1),
	table thead th:nth-child(1){
		padding-left: 20px;
	}
	
	table tbody tr td:nth-last-child(1),
	table thead th:nth-last-child(1){
		padding-right: 20px;
	}
	
	.toDetail{
		text-decoration: underline;
		cursor: pointer;
		color: #666;
	}
	
	.paginationArea{
		display: flex;
		justify-content: center;
		background-color: #fff;
		padding: 17px 0;
	}
	
	.timeLabel{
		width: 110px;
	}
</style>